import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Button} from '@travel-frontend/ui-components';

export const FilterOverlayTrigger = styled(Button)`
  > svg {
    width: 24px;
    height: 24px;
  }

  > span {
    margin-left: -12px;
  }

  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        > span {
          margin-left: -4px;
        }
      `
    )}
`;
